import { render, staticRenderFns } from "./TeamSalesStatistics.vue?vue&type=template&id=027e31b6&scoped=true"
import script from "./TeamSalesStatistics.vue?vue&type=script&lang=js"
export * from "./TeamSalesStatistics.vue?vue&type=script&lang=js"
import style0 from "./TeamSalesStatistics.vue?vue&type=style&index=0&id=027e31b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e31b6",
  null
  
)

export default component.exports